import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

/**
 * react-select multi-value changes (e.g. adding divisions) can trigger a benign
 * browser "ResizeObserver loop completed with undelivered notifications" that
 * CRA's error overlay treats as a hard failure. Ignore only that known noise.
 */
const isBenignResizeObserverError = (message: unknown): boolean =>
  typeof message === "string" &&
  (message.includes("ResizeObserver loop completed with undelivered notifications") ||
    message.includes("ResizeObserver loop limit exceeded"));

window.addEventListener("error", (event) => {
  if (isBenignResizeObserverError(event.message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

window.addEventListener("unhandledrejection", (event) => {
  const reason = event.reason;
  const message =
    typeof reason === "string"
      ? reason
      : reason && typeof reason === "object" && "message" in reason
        ? String((reason as { message?: unknown }).message || "")
        : "";
  if (isBenignResizeObserverError(message)) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
